"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalWrapper = exports.QrText = exports.QrImg = exports.ModalCTA = exports.QrCodeWrapper = exports.StyledTitle = exports.ImageWrapper = exports.ColumnContainer = exports.ContentWrapper = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const bitcoincom_pkg_theme_1 = require("@bitcoin-portal/bitcoincom-pkg-theme");
const Button_1 = __importDefault(require("../../../../Button"));
exports.ContentWrapper = styled_components_1.default.div `
  ${({ theme }) => (0, styled_components_1.css) `
    padding: ${theme.spacing.unit * 3}px ${theme.spacing.unit * 2}px
      ${theme.spacing.unit * 5}px;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    background-color: #f1f7fd;
    flex: 1;

    & > * + * {
      margin-top: 24px;
    }

    ${bitcoincom_pkg_theme_1.media.md `
      /* padding: ${theme.spacing.unit * 15}px ${theme.spacing.unit * 8}px
        ${theme.spacing.unit * 15}px; */
      padding: 56px 92px 76.5px;
      margin: 0 auto;
      box-sizing: border-box;
      overflow: hidden;
      height: 565px;
    `}
  `}
`;
exports.ColumnContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  padding: 0;
  background: ${({ theme }) => theme.palette.background.secondary};

  ${bitcoincom_pkg_theme_1.media.md `
    display: flex;
    flex-direction: row;
  `}
`;
exports.ImageWrapper = styled_components_1.default.div `
  max-width: 392px;
  display: none;
  box-sizing: border-box;
  max-height: 565px;

  ${bitcoincom_pkg_theme_1.media.md `
    display:block;
  `}

  & > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
exports.StyledTitle = styled_components_1.default.div `
  font-weight: 700;
  font-size: 24px;
  line-height: 26px;
  color: #3e4555;
  margin-top: 20px;
  ${bitcoincom_pkg_theme_1.media.lg `
    font-size: 32px;
    line-height: 38.12px;
    margin-top: 0;
  `}
`;
exports.QrCodeWrapper = styled_components_1.default.div `
  height: 220px;
  width: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0;
  background: linear-gradient(
    180deg,
    #ffffff 3.35%,
    rgba(255, 255, 255, 0.73) 100%
  );
  box-shadow: 0px 18.8889px 82.1667px rgba(45, 50, 59, 0.0200938),
    0px 9.5625px 35.8195px rgba(45, 50, 59, 0.03475),
    0px 3.77778px 13.3521px rgba(45, 50, 59, 0.0520312),
    0px 0.826389px 4.75026px rgba(45, 50, 59, 0.08);
  border-radius: 12px;
  & > div {
    width: 100%;
    padding: 10px !important;
  }
`;
exports.ModalCTA = (0, styled_components_1.default)(Button_1.default) `
  width: 154px;
  height: 48px;
  border-radius: 12px;
  position: relative;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  box-shadow: 0px 20px 87px rgba(45, 50, 59, 0.0200938),
    0px 10.125px 37.9266px rgba(45, 50, 59, 0.03475),
    0px 4px 14.1375px rgba(45, 50, 59, 0.0520312),
    0px 0.875px 5.02969px rgba(45, 50, 59, 0.08);

  & > div {
    color: #2d323b;
    font-size: 9px;
    font-weight: 500;
    line-height: 15.75px;
  }
`;
exports.QrImg = styled_components_1.default.img `
  height: 26px;
  width: 26px;
`;
exports.QrText = styled_components_1.default.span `
  white-space: normal;
  text-align: left;
  margin-left: 8px;
  font-weight: 500;
`;
exports.ModalWrapper = styled_components_1.default.div `
  #inner {
    border-style: none;
    overflow-y: clip;
    max-width: 414px;
    width: 100%;
    filter: drop-shadow(0px 20px 87px rgba(0, 0, 0, 0.1001))
      drop-shadow(0px 10.125px 38px rgba(0, 0, 0, 0.1547))
      drop-shadow(0px 4px 14px rgba(0, 0, 0, 0.25))
      drop-shadow(0px 0.875px 5px rgba(0, 0, 0, 0.4));
    svg {
      color: #0085ff !important;
      opacity: 1;
    }
    ${bitcoincom_pkg_theme_1.media.md `
      min-width: 800px;
      max-height: 565px !important;
    `}
    ${bitcoincom_pkg_theme_1.media.lg `
      min-width: 910px;
    `}
  }
  #overlay {
    background: rgba(0, 0, 0, 0.3);
  }
`;
//# sourceMappingURL=styled.js.map